export default {
  baseURL: process.env.VUE_APP_API_BASE_URL
}